import React, { Component } from 'react';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Input,
	Paper,
	InputBase,
	Divider
} from '@material-ui/core';
import {
	CloseOutlined as CloseIcon,
} from '@material-ui/icons';


const styles = (theme: Theme) => createStyles({
	root: {
		display: 'inline-block',
		width: 400,
	},
	paper: {
		padding: `${theme.spacing.unit / 4}px ${theme.spacing.unit / 2}px`,
		display: 'flex',
		alignItems: 'center',
		width: 394,
		height: 44,
		boxShadow: '0px 0px',
		background: '#FFFFFF',
		border: '1px solid #DCDCDC',
		boxSizing: 'border-box',
		borderRadius: 34,
		marginLeft: 40
	},

});

//@ts-ignore
interface MyPATDateRangeProps extends WithStyles<typeof styles> {
	classes: any,
	searchText: string,
	searchTextChanged: Function,
}

interface MyPATDateRangeState {
	searchText: string,
}

class MyPATDateRange extends Component<MyPATDateRangeProps, MyPATDateRangeState>{

	constructor(props: MyPATDateRangeProps) {
		super(props);
		if (!props.searchText) {
			props = {
				...props,
				searchText: "",
			}
		}

		this.state = {
			searchText: props.searchText
        }        
        
    }
    
    changeHandler() {
        return(
            <>
            </>
        )
    }
    
	render() {
		const { classes } = this.props;
		return (
            <>
           <input id="datepicker" onChange={this.changeHandler} />
			</>
		);
	}
}

// @ts-ignore
export default withStyles(styles)(MyPATDateRange);

